import { useStores } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export const Logout: React.FunctionComponent = observer(() => {
  const { userStore } = useStores()
  const { logout } = userStore

  const history = useHistory()

  useEffect(() => {
    logout()
    setTimeout(() => {
      history.replace('/login')
    }, 400)
  }, [])

  return null
})
